export default {"src":"/_next/static/media/youtube-small-icon.6d435cd0.svg","height":20,"width":29,"blurWidth":0,"blurHeight":0};